import { liveInterface } from '@/api/live'

// 帐号模式，0-表示独立模式，1-表示托管模式
// let accountMode = 0
// 官方 demo appid,需要开发者自己修改（托管模式）
let sdkAppID = process.env.VUE_APP_TCIMSDK_APPID
let accountType = process.env.VUE_APP_TCIMSDK_ACCOUNT_TYPE

let avLiveRoomId = '' // 直播间ID
let avChatRoomId = '' // 默认房间群ID，群类型必须是直播聊天室（AVChatRoom），这个为官方测试ID(托管模式)
let avLiveUserId = '' // 直播用户ID

let selSess = null // 当前聊天会话

// 当前用户身份
let loginInfo = {
  sdkAppID: sdkAppID, // 用户所属应用id,必填
  appIDAt3rd: sdkAppID, // 用户所属应用id，必填
  accountType: accountType, // 用户所属应用帐号类型，必填
  identifier: null, // 当前用户ID,必须是否字符串类型，选填
  identifierNick: '', // 当前用户昵称，选填
  userSig: null, // 当前用户身份凭证，必须是字符串类型，选填
  headurl: '' // 当前用户默认头像，选填
}

// 监听连接状态回调变化事件
let onConnNotify = function(resp) {
  switch (resp.ErrorCode) {
    case webim.CONNECTION_STATUS.ON:
      // webim.Log.warn('连接状态正常...');
      break
    case webim.CONNECTION_STATUS.OFF:
      webim.Log.warn('连接已断开，无法收到新消息，请检查下你的网络是否正常')
      break
    default:
      webim.Log.error('未知连接状态,status=' + resp.ErrorCode)
      break
  }
}

// IE9(含)以下浏览器用到的jsonp回调函数
function jsonpCallback(rspData) {
  // 设置接口返回的数据
  webim.setJsonpLastRspData(rspData)
}

// 设置消息体
function getMsg(msgText) {
  /**
   * 会话对象Session
   * https://cloud.tencent.com/document/product/269/4051#2.2-.E4.BC.9A.E8.AF.9D.E5.AF.B9.E8.B1.A1session
   */
  if (!selSess) {
    selSess = new webim.Session(webim.SESSION_TYPE.GROUP, avChatRoomId)
  }
  let isSend = true // 是否为自己发送
  let seq = -1 // 消息序列，-1表示sdk自动生成，用于去重
  let random = Math.round(Math.random() * 4294967296) // 消息随机数，用于去重
  let msgTime = Math.round(new Date().getTime() / 1000) // 消息时间戳
  let subType = webim.GROUP_MSG_SUB_TYPE.COMMON
  /**
   * 消息对象msg
   * https://cloud.tencent.com/document/product/269/4051#2.3-.E6.B6.88.E6.81.AF.E5.AF.B9.E8.B1.A1msg
   */
  let msg = new webim.Msg(
    selSess,
    isSend,
    seq,
    random,
    msgTime,
    loginInfo.identifier,
    subType,
    loginInfo.identifierNick
  )
  msg.addText({ text: msgText })
  return msg
}

// 发送消息
function onSendMsg(userAction, msgtosend) {
  if (!loginInfo.identifier) {
    alert('请登录')
    return
  }
  if (!avChatRoomId) {
    alert('您还没有进入房间，暂不能聊天')
    return
  }
  // 发送消息改成app自定义的格式
  let msg = getMsg(
    JSON.stringify({
      userAction: userAction || 1,
      userId: loginInfo.identifier,
      nickName: loginInfo.identifierNick,
      headPic: loginInfo.headurl,
      msg: msgtosend || ''
    })
  )
  webim.sendMsg(
    msg,
    function(resp) {
      webim.Log.info('发消息成功')
    },
    function(err) {
      webim.Log.error('发消息失败:' + err.ErrorInfo)
      console.log('发消息失败:' + err.ErrorInfo)
    }
  )
}

// 发送点赞消息
let likeLastTime = null
function onSendGroupLoveMsg(msgtosend) {
  if (!loginInfo.identifier) {
    alert('请登录')
    return
  }
  if (!avChatRoomId) {
    alert('您还没有进入房间，暂不能点赞')
    return
  }
  let likeCurrentTime = new Date().getTime()
  if (likeCurrentTime - likeLastTime > 2 * 60 * 1000) {
    likeLastTime = likeCurrentTime
    msgtosend = 'show'
  } else {
    msgtosend = ''
  }
  // 发送文本消息改成app自定义的格式
  let msg = getMsg(
    JSON.stringify({
      userAction: 4,
      userId: loginInfo.identifier,
      nickName: loginInfo.identifierNick,
      headPic: loginInfo.headurl,
      msg: msgtosend || ''
    })
  )
  webim.sendMsg(
    msg,
    resp => {
      webim.Log.info('点赞成功')
      // 调用进群后台接口
      liveInterface({
        Action: 'ChangeCount',
        fileid: '',
        flag: 0, // 0:直播 1:点播
        optype: 0, // 0:增加 1:减少
        roomid: avLiveRoomId,
        type: 1, // 0:修改观看数量 1：修改点赞数量
        userid: loginInfo.identifier // string 用户id
      })
    },
    err => {
      webim.Log.error('发送点赞消息失败:' + err.ErrorInfo)
      alert('发送点赞消息失败:' + err.ErrorInfo)
    }
  )
}

export default class Live {
  constructor(options) {
    // 直播间ID
    this.avLiveRoomId = options.avLiveRoomId
    avLiveRoomId = this.avLiveRoomId
    // 直播用户ID
    this.avLiveUserId = options.avLiveUserId
    avLiveUserId = this.avLiveUserId
    // 聊天室ID
    this.avChatRoomId = options.avChatRoomId
    avChatRoomId = this.avChatRoomId
    // 用户信息
    this.loginInfo = options.loginInfo
    loginInfo = options.loginInfo

    // 监听（多终端同步）群系统消息方法，方法都定义在demo_group_notice.js文件中
    // 注意每个数字代表的含义，比如，
    // 1表示监听申请加群消息，2表示监听申请加群被同意消息，3表示监听申请加群被拒绝消息等
    let onGroupSystemNotifys = {
      '5': this.onDestoryGroupNotify.bind(this), // 群被解散(全员接收)
      '11': this.onRevokeGroupNotify.bind(this), // 群已被回收(全员接收)
      '255': this.onCustomGroupNotify.bind(this) // 用户自定义通知(默认全员接收)
    }

    // 监听事件
    this.listeners = {
      onConnNotify: onConnNotify, // 选填
      jsonpCallback: jsonpCallback, // IE9(含)以下浏览器用到的jsonp回调函数,移动端可不填，pc端必填
      onBigGroupMsgNotify: this.onBigGroupMsgNotify.bind(this), // 监听新消息(大群)事件，必填
      onMsgNotify: this.onMsgNotify.bind(this), // 监听新消息(私聊(包括普通消息和全员推送消息)，普通群(非直播聊天室)消息)事件，必填
      onGroupSystemNotifys: onGroupSystemNotifys // 监听（多终端同步）群系统消息事件，必填
    }
    // 其他对象，选填
    this.loginOptions = {
      isAccessFormalEnv: true, // 是否访问正式环境，默认访问正式，选填
      isLogOn: false // 是否开启控制台打印日志,默认开启，选填
    }

    // callback
    // 登录后，准备完毕
    this.onReady = options.onReady
    // 消息通知回调
    this.onBigGroupMsgNotifyCallback = options.onBigGroupMsgNotifyCallback
    // 系统消息通知回调
    this.onSystemMsgNotifyCallback = options.onSystemMsgNotifyCallback
  }
  // 登录
  sdkLogin() {
    webim.login(
      this.loginInfo,
      this.listeners,
      this.loginOptions,
      () => {
        webim.Log.info('webim登录成功')
        this.applyJoinBigGroup(avChatRoomId) // 加入大群
      },
      err => {
        alert(err.ErrorInfo)
      }
    )
  }
  // 登出
  logout() {
    // 退群，调用后台接口
    liveInterface({
      Action: 'QuitGroup',
      userid: loginInfo.identifier, // string 用户id
      liveuserid: this.liveUserId, // string 主播id
      flag: 0, // 0:直播 1:点播
      roomid: avChatRoomId
    })
    // 发送退出直播消息
    this.sendMsg(3)
    webim.logout(resp => {
      webim.Log.info('登出成功')
    })
  }
  // 进入大群
  applyJoinBigGroup() {
    let options = {
      GroupId: avChatRoomId // 群id
    }
    webim.applyJoinBigGroup(
      options,
      resp => {
        // JoinedSuccess:加入成功; WaitAdminApproval:等待管理员审批
        if (resp.JoinedStatus && resp.JoinedStatus === 'JoinedSuccess') {
          webim.Log.info('进群成功')

          // 准备成功
          this.onReady && this.onReady()

          // 调用进群后台接口
          liveInterface({
            Action: 'EnterGroup',
            flag: 0, // 0:直播 1:点播
            groupid: avChatRoomId,
            headpic: loginInfo.headurl,
            liveuserid: avLiveUserId, // string 主播id
            nickname: loginInfo.identifierNick,
            roomid: avLiveRoomId,
            userid: loginInfo.identifier // string 用户id
          }).then(() => {
            // 发送加入直播消息
            this.sendMsg(2)
          })
        } else {
          alert('进群失败')
        }
      },
      err => {
        console.log('applyJoinBigGroup: 进群失败', err)
        if (err.ErrorCode === 10010) {
          alert('直播已结束(' + err.ErrorCode + ')')
        } else if (err.ErrorCode === 10013) {
          alert('进群失败 : ' + err.ErrorInfo)
        } else {
          alert('进群失败 : ' + err.ErrorInfo)
        }
      }
    )
  }
  // 退出大群
  quitBigGroup() {
    let options = {
      GroupId: avChatRoomId // 群id
    }
    webim.quitBigGroup(
      options,
      resp => {
        webim.Log.info('退群成功')
      },
      err => {
        alert(err.ErrorInfo)
      }
    )
  }
  // 发送消息
  sendMsg(userAction, msg) {
    onSendMsg(userAction, msg)
  }
  // 发送点赞消息
  sendGroupLoveMsg(msg) {
    onSendGroupLoveMsg(msg)
  }
  // 获取用户列表
  fetchGroupMemberList() {
    return liveInterface({
      Action: 'FetchGroupMemberList',
      roomid: avLiveRoomId,
      liveuserid: avLiveUserId,
      groupid: avChatRoomId,
      pageno: 1,
      pagesize: 20
    })
  }
  // 获取导览列表
  fetchGuideList() {
    return liveInterface({
      Action: 'guideList',
      roomid: avLiveRoomId
    })
  }
  // 监听大群新消息（普通，点赞，提示，红包）
  onBigGroupMsgNotify(msgList) {
    for (let i = msgList.length - 1; i >= 0; i--) {
      // 遍历消息，按照时间从后往前
      let msg = msgList[i]
      webim.Log.warn(
        'receive a new avchatroom group msg: ' + msg.getFromAccountNick()
      )
      this.handlerMsg(msg)
      this.onBigGroupMsgNotifyCallback && this.onBigGroupMsgNotifyCallback(msg)
    }
  }
  // 监听 解散群 系统消息
  onDestoryGroupNotify(notify) {
    webim.Log.warn('执行 解散群 回调：' + JSON.stringify(notify))
    this.onSystemMsgNotify(notify)
  }

  // 监听 群被回收 系统消息
  onRevokeGroupNotify(notify) {
    webim.Log.warn('执行 群被回收 回调：' + JSON.stringify(notify))
    this.onSystemMsgNotify(notify)
  }

  // 监听 用户自定义 群系统消息
  onCustomGroupNotify(notify) {
    webim.Log.warn('执行 用户自定义系统消息 回调：' + JSON.stringify(notify))
    this.onSystemMsgNotify(notify)
  }
  // 监听新消息(私聊(包括普通消息、全员推送消息)，普通群(非直播聊天室)消息)事件
  // newMsgList 为新消息数组，结构为[Msg]
  onMsgNotify(newMsgList) {
    let newMsg
    for (let j in newMsgList) {
      // 遍历新消息
      newMsg = newMsgList[j]
      console.log(newMsg)
    }
  }
  // 系统消息通知
  onSystemMsgNotify(msg) {
    this.onSystemMsgNotifyCallback && this.onSystemMsgNotifyCallback(msg)
  }
  handlerMsg(msg, callback) {
    let subType = msg.getSubType()
    if (subType === webim.GROUP_MSG_SUB_TYPE.COMMON) {
      let elems = msg.getElems() // 获取消息包含的元素数组
      for (let i in elems) {
        let elem = elems[i]
        let type = elem.getType() // 获取元素类型
        let content = elem.getContent() // 获取元素对象
        if (type === webim.MSG_ELEMENT_TYPE.TEXT) {
          let data = content.getData()
          callback && callback(data)
        }
      }
    }
  }
}
